import type { SxProps, Theme } from '@mui/material'

export const segmentedPillsStyles = {
  container: (theme: Theme): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    gap: 0.25,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${(theme.palette as any).gray?.[12] ?? theme.palette.divider}`,
    borderRadius: 2,
    p: 0.375,
    overflowX: 'auto',
    flexShrink: 1,
    minWidth: 0,
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': { display: 'none' },
  }),

  pill: (isActive: boolean): SxProps<Theme> => {
    const base = {
      px: 1.5,
      py: 0.5,
      borderRadius: 1.5,
      fontSize: '0.8125rem',
      fontWeight: 600,
      cursor: 'pointer',
      userSelect: 'none' as const,
      whiteSpace: 'nowrap' as const,
      transition: 'all 0.15s ease',
      lineHeight: 1.6,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 0.75,
      flex: 1,
    }

    if (isActive) {
      return {
        ...base,
        backgroundColor: 'primary.lightest',
        color: 'primary.main',
      }
    }

    return {
      ...base,
      backgroundColor: 'transparent',
      color: 'text.secondary',
      '&:hover': {
        backgroundColor: 'action.hover',
        color: 'text.primary',
      },
    }
  },

  pillLabel: {
    fontSize: '0.8125rem',
    fontWeight: 'inherit',
    color: 'inherit',
    lineHeight: 1.6,
  } as SxProps<Theme>,
}
